import Vue from 'vue';
// 非关联性组件穿传参
const bus = new Vue();
export default bus;